module.exports = __webpack_public_path__ + "static/media/Glacial-Indifference.bc05faea.svg";